import { Trans } from 'react-i18next';
export default Trans;
